import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CountryCode } from 'libphonenumber-js';
import { formatPhoneNumber } from '../../../../../utilities/PhoneUtility';
import { UserContextProvider } from '../../../../../infrastructure/context/user-context-provider';

@Component({
  selector: 'app-basic-info-step',
  templateUrl: './basic-info-step.component.html',
  styleUrls: ['./basic-info-step.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    MatExpansionModule, 
    MatIconModule, 
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDatepickerModule
  ]
})
export class BasicInfoStepComponent {

  @Input('basicInformationForm') form!: FormGroup;

  panelOpen: boolean = false;
  maxBirthDate: Date = new Date();

  constructor(private userContextProvider: UserContextProvider) { }

  onPhoneNumberChanged(event: Event) {
    this.updatePhoneNumber((event.target as HTMLInputElement).value);
  }

  updatePhoneNumber(phoneNumber: string) {
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber, this.userContextProvider.countryCode as CountryCode);
    this.form.patchValue({ phone: formattedPhoneNumber });
  }
}